import React from "react";

export default function PageLoading() {
  return (
    <div className="">
      <style>
        {`  <div>
      <style>
      .loading-screen {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #ffffff;
        z-index: 9999;
      }

      .spinners {
        width: 48px;
        height: 48px;
        border: 3px solid rgba(59, 130, 246, 0.2);
        border-top: 3px solid #3b82f6;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 24px;
      }

      .loading-subtitle {
        color: rgba(0, 0, 0, 0.6);
        font-size: 14px;
        font-weight: 400;
        animation: fadeInUp 0.4s ease-out 0.1s both;
      }

        @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

       @keyframes fadeInUp {
        0% {
          opacity: 0;
          transform: translateY(20px);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }

      </style>
      <div class="loading-screen">
        <div class="spinners"></div>
      </div>
    </div>`}
      </style>
      <div class="loading-screen w-full h-screen flex flex-col items-center justify-center">
        <div class="spinners"></div>
        <div class="loading-subtitle">Please wait a moment</div>
      </div>
    </div>
  );
}
